module.exports = __webpack_public_path__ + "static/media/webapp-background.69618dbf.jpg";